import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import swipe from "@ts/utils/alpine-swipe-plugin";

window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(swipe);
Alpine.plugin(collapse);
